<div class="page gray-font-color font-family profile-license">
  <div class="header-navigation-back">
    <mat-icon (click)="onNavigateBack()" data-test="back-arrow-icon">arrow_back</mat-icon>
    <span class="title" data-test="edit-button">{{ getHeaderTitle() }}</span>
  </div>

  <!-- Document Extract Loading Overlay -->
  @if (isExtracting) {
    <div class="extraction-overlay">
      <div class="extraction-content">
        <mat-spinner diameter="60" color="primary"></mat-spinner>
        <div class="extraction-message">
          <h3>Extracting license information<span class="dots"></span></h3>
          <p>Please wait while we automatically read your license details</p>
        </div>
      </div>
    </div>
  }

  @if (isApiLoading) {
    <div class="loading-container">
      <div class="loading-content">
        <img src="/assets/icons/fleetoperate-dots-loading.gif" class="loading-gif" />
        <span class="upload-message" data-testid="uploadStatus-message">Upload in progress... Please wait and don't refresh the screen.</span>
      </div>
    </div>
  }

  @if (!isApiLoading && finalImageFiles?.length != 2 && !showCrop) {
    <div class="license-upload-container">
      <!-- Upload Section -->
      <div class="upload-section">
        <div class="section-header">
          <h3>License Image</h3>
          <p class="section-subtitle">{{ !isFrontSave ? 'Upload the front side of your license' : 'Upload the back side of your license' }}</p>
        </div>
        
        <div class="upload-area">
          <div class="license-preview">
            <img
              [src]="!isFrontSave ? 'assets/images/dl-front.png' : 'assets/images/dl-back.png'"
              class="license-placeholder-image"
              alt="{{ !isFrontSave ? 'Front license placeholder' : 'Back license placeholder' }}"
            />
          </div>
          
          <div class="upload-actions">
            <button 
              mat-raised-button 
              class="upload-image-button" 
              (click)="openGallery(fileInput)" 
              data-testid="upload-btn"
            >
              <mat-icon>add_photo_alternate</mat-icon>
              {{ !isFrontSave ? 'Upload Front Side' : 'Upload Back Side' }}
            </button>
            <input #fileInput type="file" hidden (change)="onProcessPictureFile($event)" [accept]="acceptTypesPicture" />
          </div>
          
          <div class="upload-info">
            <div class="info-notice">
              <mat-icon class="info-icon">info</mat-icon>
              <span>JPEG, JPG and PNG are supported document types. Maximum file size: 2.5MB</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  }

  @if (!isApiLoading && showCrop) {
    <div class="crop-mode-container">
      <!-- Crop Header -->
      <div class="crop-header">
        <h2 class="crop-title">Adjust Your License Image</h2>
        <p class="crop-subtitle">Position and rotate your license image for the best quality</p>
      </div>


      <!-- Image Cropper Section -->
      <div class="cropper-section">
        <!-- Loading Overlay -->
        @if (loading) {
          <div class="cropper-loading-overlay">
            <div class="cropper-loading-state">
              <mat-spinner diameter="40"></mat-spinner>
              <p>Processing image...</p>
            </div>
          </div>
        }
        
        <!-- Image Cropper -->
        <div class="cropper-container" [class.cropper-hidden]="loading">
          <image-cropper
            #previewImage
            [imageChangedEvent]="imageChangedEvent"
            [maintainAspectRatio]="false"
            [imageQuality]="100"
            cropperMinWidth="420"
            cropperMinHeight="230"
            [cropperStaticWidth]="420"
            [cropperStaticHeight]="240"
            [cropperPosition]="cropperPosition"
            [aspectRatio]="4 / 4"
            [roundCropper]="false"
            [canvasRotation]="canvasRotation"
            [transform]="transform"
            [format]="imageFormat"
            (imageCropped)="onImageCropped($event)"
            (imageLoaded)="onImageLoaded()"
            (cropperReady)="onCropperReady()"
            (loadImageFailed)="onLoadImageFailed()"
          >
          </image-cropper>
        </div>
      </div>

      <!-- Rotate Controls -->
      @if (!loading) {
        <div class="rotation-buttons">
          <button mat-raised-button class="rotate-button" (click)="rotateLeft()" data-testid="rotateLeft-btn">
            <mat-icon>rotate_left</mat-icon>
          </button>
          <button mat-raised-button class="rotate-button" (click)="rotateRight()" data-testid="rotateRight-btn">
            <mat-icon>rotate_right</mat-icon>
          </button>
        </div>
      }

      <!-- Action Buttons -->
      <div class="crop-actions">
        <button mat-raised-button class="cancel-button" (click)="onCancelCrop()" data-testid="cancel-btn">
          <mat-icon>close</mat-icon>
          Cancel
        </button>
        <button mat-raised-button class="save-button" (click)="onFinishCrop()" data-testid="finish-btn" [disabled]="loading || isApiLoading">
          @if (isApiLoading) {
            <mat-spinner diameter="16"></mat-spinner>
          } @else {
            <mat-icon>check</mat-icon>
          }
          {{ isApiLoading ? 'Saving...' : 'Save' }}
        </button>
      </div>
    </div>
  }
  </div>
